<template>
  <div class="page-header-index-wide">
    <a-row :gutter="24">
      <a-col :sm="24" :md="24" :xl="24" :style="{ marginBottom: '24px'}">
        <div style="font-size: large;font-weight: bold">
          每日拣选数量
        </div>
        <iframe
          width="1200"
          height="400"
          seamless
          frameBorder="0"
          scrolling="no"
          :src="everydayShipmentUrl"
        >
        </iframe>
      </a-col>
      <a-col :sm="24" :md="24" :xl="16" :style="{ marginBottom: '24px' }">
        <div style="font-size: large;font-weight: bold">
          每月拣选数量
        </div>
        <iframe
          width="1200"
          height="400"
          seamless
          frameBorder="0"
          scrolling="no"
          :src="everyMonthShipmentUrl"
        >
        </iframe>
      </a-col>
      <a-col :sm="24" :md="24" :xl="24" :style="{ marginBottom: '24px' }">
        <div style="font-size: large;font-weight: bold">
          每日补货数量
        </div>
        <iframe
          width="1200"
          height="400"
          seamless
          frameBorder="0"
          scrolling="no"
          :src="everydayReceiptUrl"
        >
        </iframe>
      </a-col>
      <a-col :sm="24" :md="24" :xl="16" :style="{ marginBottom: '24px' }">
        <div style="font-size: large;font-weight: bold">
          每月补货数量
        </div>
        <iframe
          width="1200"
          height="400"
          seamless
          frameBorder="0"
          scrolling="no"
          :src="everyMonthReceiptUrl"
        >
        </iframe>
      </a-col>
      <a-col :sm="24" :md="24" :xl="24" :style="{ marginBottom: '24px' }">
        <div style="font-size: large;font-weight: bold">
          每日下架数量
        </div>
        <iframe
          width="1200"
          height="400"
          seamless
          frameBorder="0"
          scrolling="no"
          :src="everydayPutdownUrl"
        >
        </iframe>
      </a-col>
      <a-col :sm="24" :md="24" :xl="16" :style="{ marginBottom: '24px' }">
        <div style="font-size: large;font-weight: bold">
          每月下架数量
        </div>
        <iframe
          width="1200"
          height="400"
          seamless
          frameBorder="0"
          scrolling="no"
          :src="everyMonthPutdownUrl"
        >
        </iframe>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import api from '@/api/index'
  export default {
    name: 'EverydayData',
    data () {
      return {
        everydayShipmentUrl:api.BIServerUrl + api.BIEveryDayShipmentQuantity,
        everydayReceiptUrl: api.BIServerUrl + api.BIEveryDayReceiptQuantity,
        everydayPutdownUrl:api.BIServerUrl + api.BIEveryDayPutdwonQuantity,
        everyMonthShipmentUrl:api.BIServerUrl + api.BIEveryMonthShipmentQuantity,
        everyMonthReceiptUrl: api.BIServerUrl + api.BIEveryMonthReceiptQuantity,
        everyMonthPutdownUrl:api.BIServerUrl + api.BIEveryMonthPutdwonQuantity
      }
    },
    created () {
    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .extra-wrapper {
    line-height: 55px;
    padding-right: 24px;

    .extra-item {
      display: inline-block;
      margin-right: 24px;

      a {
        margin-left: 24px;
      }
    }
  }

  .antd-pro-pages-dashboard-analysis-twoColLayout {
    position: relative;
    display: flex;
    display: block;
    flex-flow: row wrap;

    &.desktop div[class^=ant-col]:last-child {
      position: absolute;
      right: 0;
      height: 100%;
    }
  }

  .antd-pro-pages-dashboard-analysis-salesCard {
    height: calc(50% - 12px);
    /deep/ .ant-card-head {
      position: relative;
    }
  }

  .dashboard-analysis-iconGroup {
    i {
      margin-left: 16px;
      color: rgba(0,0,0,.45);
      cursor: pointer;
      transition: color .32s;
      color: black;
    }
  }
  .analysis-salesTypeRadio {
    position: absolute;
    right: 54px;
    bottom: 12px;
  }
</style>
